module.exports = __webpack_public_path__ + "img/secret.9bb020f3.png";